import {
  BrowserRouter as Router, 
  Route, 
  Routes
} from "react-router-dom";
import Header from "./components/Header";
import HomePage from "./pages/HomePage";
import TermPage from "./pages/TermPage";
import PrivacyPage from "./pages/PrivacyPage";
import SupportPage from "./pages/SupportPage";
import './App.css';

function App() {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/terms" element={<TermPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/support" element={<SupportPage />} />
      </Routes>
    </Router>
  );
}

export default App;
